const MixinCharts = {
  data() {
    return {
      paleta_color: [
        "#1ABC9C",
        "#0089C7",
        "#DE6C47",
        "#FFB311",
        "#F9F966",
        "#d13814",
        "#9b59b6",
        "#f17cb0",
        "#84754e",
        "#003666",
        "#EACA69",
        "#00B4FF",
        "#F97566"
      ]
    };
  },

  methods: {
    spline(title_, subtitle_, categories_, series_, percent = false, showValue_ = false) {
      let chartOptions = {
        chart: {
          zoomType: "xy",
          type: "spline"
        },
        title: {
          text: title_ ? title_ : "Titulo del Gráfico",
          x: -20
        },
        subtitle: {
          text: subtitle_ ? subtitle_ : "Sub Titulo del Gráfico",
          x: -20
        },
        xAxis: {
          categories: categories_
        },
        yAxis: {
          title: {
            text: "Nro Ticket"
          },
          labels: {
            format: "{value}" + (percent ? '%' : ''),
          }
        },
        tooltip: {
          shared: true
        },
        plotOptions: {
          spline: {
            dataLabels: {
              enabled: showValue_,
              color: "black"
            }
          }
        },
        series: series_
      };

      return chartOptions;
    },

    pie(title_, subtitle_, series_, drilldown_, percent = false) {
      let chartOptions = {
        colors: this.paleta_color,
        chart: {
          plotBackgroundColor: null,
          plotBorderWidth: 0,
          plotShadow: false,
          type: 'pie',
          /* events: {
            drilldown: function(e) {
              if (!e.seriesOptions) {
                this.vueRef.updateGraph(true, this, e);
              }
            },
            drillup: function(e) {
              if (!e.seriesOptions.flag) {
                this.vueRef.drilldownLevel = e.seriesOptions._levelNumber;
                this.vueRef.updateGraph(false);
              }
            }
          } */
        },
        title: {
          text: title_
        },
        subtitle: {
          text: subtitle_
        },
        accessibility: {
          announceNewData: {
              enabled: true
          },
          point: {
              valueSuffix: (percent ? '%' : '')
          }
        },
        plotOptions: {
          series: {
            shadow: true,
            allowPointSelect: true,
            cursor: 'pointer',
            dataLabels: {
                enabled: true,
                format: '{point.name}: {point.y:.f}' + (percent ? '%' : '')
            }
          },
        },
        tooltip: {
          headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
          pointFormat: '<span style="color:{point.color}">{point.name}</span>: <b>{point.y:.f}' + (percent ? '%' : '')
        },
        series: series_,
        drilldown: drilldown_
      };

      return chartOptions;
    },

    formatMoney(amount, decimalCount = 2, decimal = ".", thousands = ",") {
      try {
        decimalCount = Math.abs(decimalCount);
        decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

        const negativeSign = amount < 0 ? "-" : "";

        let i = parseInt(
          (amount = Math.abs(Number(amount) || 0).toFixed(decimalCount))
        ).toString();
        let j = i.length > 3 ? i.length % 3 : 0;

        let response =
          negativeSign +
          (j ? i.substr(0, j) + thousands : "") +
          i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) +
          (decimalCount
            ? decimal +
              Math.abs(amount - i)
                .toFixed(decimalCount)
                .slice(2)
            : "");

        return response.replace(/([0-9]+(\.[0-9]+[1-9])?)(\.?0+$)/, "$1");
      } catch (e) {
        console.log(e);
      }
    },
  },
};

export default MixinCharts;
